import { render, staticRenderFns } from "./iDEAL.vue?vue&type=template&id=6cca322d&scoped=true&"
import script from "./iDEAL.vue?vue&type=script&lang=js&"
export * from "./iDEAL.vue?vue&type=script&lang=js&"
import style0 from "./iDEAL.vue?vue&type=style&index=0&id=6cca322d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cca322d",
  null
  
)

export default component.exports